// src/pages/ShopPage.js
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/firestore";

import FilteredProductList from "../Components/FilteredProductList";
import Cart from "../Components/Cart";

const ShopPage = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      const snapshot = await getDocs(collection(db, "products"));
      const items = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setProducts(items);
    };
    fetchProducts();
  }, []);

  return (
    <div>
      {/* Витрина */}
      <FilteredProductList products={products} />

      {/* Корзина */}
      <Cart products={products} />
    </div>
  );
};

export default ShopPage;
